import { EntryPoint, StudyLevel, StudyMode, IProgrammeChoice } from 'types';

export interface ProgrammeChoiceFormValues {
  courseId?: string;
  courseName?: string;
  intakeId?: string;
  studyLevel?: string;
  mode?: string;
  campus?: string;
  entryPoint?: string;
}

export function structureProgrammeChoicesObject(values: ProgrammeChoiceFormValues): IProgrammeChoice[] {
  const { courseId, courseName, intakeId, studyLevel, mode, campus, entryPoint } = values;

  // All fields are required to create a programme choice
  if (!courseId || !intakeId || !studyLevel || !mode || !campus || !entryPoint) {
    return [];
  }

  return [
    {
      courseId,
      courseName: courseName || '',
      intakeId,
      intendedLevelOfStudy: studyLevel as StudyLevel,
      mode: mode as StudyMode,
      campus,
      entryPoint: (entryPoint as EntryPoint) || EntryPoint.Year1,
    },
  ];
}
